import {Component, type ReactNode} from 'react';

export class EditorErrorBoundary extends Component<{children: ReactNode}, {error: string | null}> {
  state = {error: null as string | null};
  static getDerivedStateFromError(error: Error) { return {error: error.message}; }
  render() {
    return this.state.error ? <main role="alert">
      <h1>편집기 연결을 확인해야 합니다.</h1><pre>{this.state.error}</pre>
    </main> : this.props.children;
  }
}
